module.exports = __webpack_public_path__ + "img/file-download.6c84e6f5.svg";